var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-chart',{staticClass:"chart",style:(_vm.chartStyle),attrs:{"option":_vm.option},on:{"click":_vm.openDescriptionModal}}),_c('description-modal',{ref:"descriptionModal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }